import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AudioServiceService {

  currentAudio = null;

  audioCollectionn = [
    // {
    //   audio: new Audio("../../assets/sound/main_track.mp3"),
    //   name: 'chooseGame',
    //   loop: true
    // },
    // {
    //   audio: new Audio('../../assets/sound/Metal.mp3'),
    //   name: 'matchGame',
    //   loop: true
    // },
    // {
    //   audio: new Audio('../../assets/sound/Darkness.mp3'),
    //   name: 'triviaGame',
    //   loop: true
    // },
    // {
    //   audio: new Audio('../../assets/sound/Pop_Up_2.mp3'),
    //   name: 'popUp',
    //   loop: false
    // },
    {
      audio: new Audio('../../assets/sound/sss/correctTrivia.wav'),
      name: 'correctTrivia',
      loop: false
    },
    {
      audio: new Audio('../../assets/sound/sss/incorrect.mp3'),
      name: 'incorrect',
      loop: false
    },
    {
      audio: new Audio('../../assets/sound/sss/pop4.mp3'),
      name: 'pop4',
      loop: false
    },
    {
      audio: new Audio('../../assets/sound/sss/open_map.wav'),
      name: 'openMap',
      loop: false
    },
    {
      audio: new Audio('../../assets/sound/sss/close_map.wav'),
      name: 'closeMap',
      loop: false
    },
    {
      audio: new Audio('../../assets/sound/sss/changeStation.wav'),
      name: 'changeStation',
      loop: false
    },
    {
      audio: new Audio('../../assets/sound/sss/gameOver.mp3'),
      name: 'gameOver',
      loop: false
    },
    {
      audio: new Audio('../../assets/sound/sss/winner.mp3'),
      name: 'winner',
      loop: false
    },
    {
      audio: new Audio('../../assets/sound/sss/newStations.wav'),
      name: 'newStations',
      loop: false
    }
  ]

  audioArr;
  // chooseGame = new Audio("../../assets/sound/main_track.mp3");
  // matchGame = new Audio('../../assets/sound/Metal.mp3');
  // popUp2 = new Audio('../../assets/sound/Pop_Up_2.mp3');

  constructor() { }

  // loadSounds() {
  //   this.audioArr = Object.values(this.audioCollection);
  //   this.audioArr.forEach((sound, index) => {
  //     if (index == 0 || index == 1 || index == 2) {
  //       sound.loop = true;
  //     }
  //     sound.autoplay = true;
  //     sound.muted = true;
  //     sound.load();
  //   });
  // }

  loadSounds() {
    this.audioCollectionn.forEach(sound => {
      if (sound.loop) {
        sound.audio.loop = true;
      }
      sound.audio.autoplay = true;
      sound.audio.muted = true;
      sound.audio.load();
    });
  }

  // playAudio(audio) {
  //   this.audioArr.forEach(sound => {
  //     sound.muted = true;
  //   });
  //   let sound = this.audioCollection[audio];
  //   sound.muted = false;
  //   sound.currentTime = 0;
  // }

  playAudio(audio, pageAudio?) {
    if (pageAudio) {
      if (audio != this.currentAudio) {
        this.currentAudio = audio;
        this.audioCollectionn.forEach(sound => {
          if (sound.name != audio) {
            sound.audio.muted = true;
          } else {
            console.log("found!!!");

            sound.audio.currentTime = 0;
            sound.audio.muted = false;
            sound.audio.load();
          }
        });
      }
    } else {
      // this.audioCollectionn.forEach(sound => {
      //   if (sound.name != audio) {
      //     sound.audio.muted = true;
      //   } else {
      //     sound.audio.currentTime = 0;
      //     sound.audio.muted = false;
      //     sound.audio.load();
      //   }
      // });
      let foundAudio = this.audioCollectionn.find(aud => aud.name == audio);
      if (foundAudio) {
        foundAudio.audio.currentTime = 0;
        foundAudio.audio.muted = false;
        foundAudio.audio.load();
      }
    }
  }
  // if(pageAudio && audio != this.currentAudio) {
  // let foundAudio = this.audioCollectionn.find(aud => aud.name == audio);
  // }
  stopAudio(audio) {
    let foundAudio = this.audioCollectionn.find(aud => aud.name == audio);
    if (foundAudio) {
      console.log(foundAudio);
      
      foundAudio.audio.currentTime = 0;
      foundAudio.audio.muted = true;
      foundAudio.audio.load();
    }
  }
}
